// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — settings.styled.classic.js, новая — settings.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './settings.styled.classic';
import * as cp from './settings.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
export const Label = isCp ? cp.Label : classic.Label;
export const TypeSelector = isCp ? cp.TypeSelector : classic.TypeSelector;
